"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _antd = require("antd");
var _reactRouterDom = require("react-router-dom");
require("./horizontal-menu.css");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
// Horizontal menu component for using at the hat of layout (optional)
var HorizontalMenu = /*#__PURE__*/function (_React$Component) {
  _inherits(HorizontalMenu, _React$Component);
  var _super = _createSuper(HorizontalMenu);
  function HorizontalMenu(props) {
    var _this;
    _classCallCheck(this, HorizontalMenu);
    _this = _super.call(this, props);
    _this.state = {
      current: "one"
    };
    console.log("HorizontalMenu props", _this.props);
    return _this;
  }

  // Handling clicks
  _createClass(HorizontalMenu, [{
    key: "handleClick",
    value: function handleClick(e) {
      var _this2 = this;
      var contentFields = document.querySelectorAll(".ant-layout-content .Paper");
      contentFields.forEach(function (field) {
        console.log("field ", field, "\nthis.state: ", _this2.state);
        switch (e.key) {
          case "one":
            field.className = "Paper Wide";
            break;
          case "two":
            field.className = "Paper Middle";
            break;
          case "three":
            field.className = "Paper Narrow";
            break;
          default:
            break;
        }
      });
      console.log("click ", e);
      this.setState({
        current: e.key
      });
    }
  }, {
    key: "createMenu",
    value: function createMenu() {
      var _this3 = this;
      this.menu = [];
      this.props.items.forEach(function (item) {
        _this3.menu.push( /*#__PURE__*/_react["default"].createElement(_antd.Menu.Item, {
          key: item.path
        }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
          to: item.path
        }, item.title), /*#__PURE__*/_react["default"].createElement("div", {
          className: "highlight"
        })));
      });
    }
  }, {
    key: "render",
    value: function render() {
      this.createMenu();
      console.log("HorizontalMenu this.props", this.props);
      return /*#__PURE__*/_react["default"].createElement(_antd.Menu, {
        selectedKeys: [this.state.current],
        mode: "horizontal",
        className: "horisontal"
      }, this.menu);
    }
  }, {
    key: "render2",
    value: function render2() {
      var _this4 = this;
      console.log("HorizontalMenu this.props", this.props);
      return /*#__PURE__*/_react["default"].createElement(_antd.Menu, {
        onClick: function onClick(e) {
          return _this4.handleClick(e);
        },
        selectedKeys: [this.state.current],
        mode: "horizontal",
        className: "horisontal"
      }, /*#__PURE__*/_react["default"].createElement(_antd.Menu.Item, {
        key: "one"
      }, "Wide layout", /*#__PURE__*/_react["default"].createElement("div", {
        className: "highlight"
      })), /*#__PURE__*/_react["default"].createElement(_antd.Menu.Item, {
        key: "two"
      }, "Middle layout", /*#__PURE__*/_react["default"].createElement("div", {
        className: "highlight"
      })), /*#__PURE__*/_react["default"].createElement(_antd.Menu.Item, {
        key: "three"
      }, "Narrow layout", /*#__PURE__*/_react["default"].createElement("div", {
        className: "highlight"
      })));
    }
  }]);
  return HorizontalMenu;
}(_react["default"].Component);
var _default = exports["default"] = HorizontalMenu;